import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// SPAs keep scroll position across navigations — reset to the top on every
// route change so a link clicked from mid-page opens the new page at the top.
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
